<template>
  <div class="footer">
    <div class="container">
      <div class="pc">
        <el-row :gutter="20">
          <el-col :sm="14">
            <span class="inblock">
              主办单位
              <el-image
                class="logo"
                fit="contain"
                :src="require('@/assets/images/tjxd/footer-logo-1.png')"
                @click="viewXd"
              ></el-image>
            </span>
            <span class="inblock">
              技术支持
              <el-image
                class="logo logo-2"
                fit="contain"
                :src="require('@/assets/images/tjxd/footer-logo-2.png')"
                @click="viewPeople"
              ></el-image>
            </span>
          </el-col>
          <el-col :sm="10">
            友情链接：
            <el-link
              class="friendship-link"
              href="http://mooc.people.cn"
              target="_blank"
              :underline="false"
            >人民网</el-link>
            <el-link
              class="friendship-link"
              href="http://www.qstheory.cn/"
              target="_blank"
              :underline="false"
            >求是网</el-link>
            <el-link
              class="friendship-link"
              href="http://www.dswxyjy.org.cn/GB/index.html"
              target="_blank"
              :underline="false"
            >中国共产党网</el-link>
            <el-link
              class="friendship-link"
              href="https://www.hcwqq.com"
              target="_blank"
              :underline="false"
            >红村网</el-link>
            <el-link
              class="friendship-link"
              href="https://www.cnki.net"
              target="_blank"
              :underline="false"
            >中国知网——党政/红色专题</el-link>
            <br />Copyright© 天津现代职业技术学院 版权所有
            <br />京公网安备 11010502036460号
          </el-col>
        </el-row>
      </div>
      <div class="mobile">
        主办单位：天津现代职业技术学院
        <br />技术支持：人民公开课
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    viewXd() {
      window.open("http://www.xdxy.com.cn/");
    },
    viewPeople() {
      window.open("http://mooc.people.cn");
    }
  }
};
</script>

<style scoped>
.footer {
  background-color: #fff;
}

.container {
  padding-top: 30px;
  padding-bottom: 30px;
  color: #9294a1;
  font-size: 12px;
  line-height: 26px;
}

.inblock {
  margin-top: 7px;
  display: inline-block;
}

.logo {
  margin-left: 18px;
  margin-right: 50px;
  max-width: 200px;
  height: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.logo-2 {
  max-width: 150px;
}

.friendship-link {
  margin-left: 10px;
  font-size: 12px;
  font-weight: normal;
  line-height: 26px;
  vertical-align: top;
  color: #9294a1 !important;
}

.friendship-link:hover {
  color: #ec2f08 !important;
}

@media (max-width: 767px) {
  .footer {
    background-color: #eee;
  }

  .container {
    padding-top: 16px;
    padding-bottom: 16px;
    color: #444;
    line-height: 22px;
    text-align: center;
  }
}
</style>
